import { ETypZavislosti } from 'enums/isin/udaje/typZavislosti';

const typZavislostiSelect = [
    {
        value: ETypZavislosti.A,
        labelcz: 'ISIN_EMISE_CERTIFIKAT_TYP_ZAV_PA'
    },
    {
        value: ETypZavislosti.N,
        labelcz: 'ISIN_EMISE_CERTIFIKAT_TYP_ZAV_N'
    },
    {
        value: ETypZavislosti.O,
        labelcz: 'ISIN_EMISE_CERTIFIKAT_TYP_ZAV_O'
    }
];

export default typZavislostiSelect;
